import actions from "./actions";

const {
    FETCH_MCW_SCHEDULE_LIST,
    FETCH_MCW_SCHEDULE,
    RESET_MCW_SCHEDULE_FORM
} = actions;

const initState = {
    // Stores the list, pagination info, and total count
    mcwSchedules: {
        page: 0,
        perPage: 35,
        data: [],
        total: 0
    },
    // Stores the specific MCW being edited or viewed
    mcwSchedule: { _id: null }
};

const MCWScheduleReducer = (state = initState, action) => {
    const { type, data } = action;

    switch (type) {
        case FETCH_MCW_SCHEDULE_LIST:
            return {
                ...state,
                mcwSchedules: data
            };
        case FETCH_MCW_SCHEDULE:
            return {
                ...state,
                mcwSchedule: data
            };
        case RESET_MCW_SCHEDULE_FORM:
            return {
                ...state,
                mcwSchedule: initState.mcwSchedule
            };
        default:
            return state;
    }
};

export default MCWScheduleReducer;